// extracted by mini-css-extract-plugin
export default {"notifications_provider_container":"NotificationProvider_notifications_provider_container__-z4Sv","notifications_container":"NotificationProvider_notifications_container__JAm2U"};